/**
 * @generated SignedSource<<832115e824610a306acc09e6458ecd7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientMealLoggingEntriesListItem_mealLoggingEntry$data = {
  readonly date: string | null | undefined;
  readonly description: string;
  readonly id: string;
  readonly photoURL: string | null | undefined;
  readonly time: string;
  readonly " $fragmentType": "ClientMealLoggingEntriesListItem_mealLoggingEntry";
};
export type ClientMealLoggingEntriesListItem_mealLoggingEntry$key = {
  readonly " $data"?: ClientMealLoggingEntriesListItem_mealLoggingEntry$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClientMealLoggingEntriesListItem_mealLoggingEntry">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClientMealLoggingEntriesListItem_mealLoggingEntry",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "photoURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "raw",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "date",
      "storageKey": "date(raw:true)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "time",
      "storageKey": null
    }
  ],
  "type": "MealLoggingEntry",
  "abstractKey": null
};

(node as any).hash = "41a7ae45a0c58afd0cd828ce7a660324";

export default node;
